export default __webpack_public_path__ + "static/media/hyundai.7e949b8d.ico";